import { isFieldSectionKey } from '@sportninja/common/features/profile/player/playerDetails/utils/sectionFields'
import { profileExtraSectionHasEditableFields } from '@sportninja/common/features/profile/player/playerDetails/utils/playerProfileExtras'
import type { ScrollSpyItem } from 'src/components/ScrollSpyLayout'
import { ROSTER_PLAYER_SETUP_ITEMS } from '../rosterPlayerSetupItems'

// Add-existing (copy): only Personal + Roster Information, plus Membership —
// the BE keeps the player's own address/emergency/social/membership values, but
// Membership still hosts the roster identifiers (Customer Identifier +
// Salesforce ID).
const ADD_EXISTING_KEYS: ReadonlySet<string> = new Set([
  'personal',
  'rosterInfo',
  'membership',
])

interface GetRosterSetupItemsArgs {
  isAddExisting: boolean
  showFamilySection: boolean
  /**
   * Editing an existing player. Adding drops the Player Details sections that
   * only display registration values (Notes), which a new player has none of.
   */
  isEdit?: boolean
}

/** The sidebar items the roster player modal shows for its current mode. */
export const getRosterSetupItems = ({
  isAddExisting,
  showFamilySection,
  isEdit = false,
}: GetRosterSetupItemsArgs): ScrollSpyItem[] => {
  if (isAddExisting) {
    return ROSTER_PLAYER_SETUP_ITEMS.filter((item) =>
      ADD_EXISTING_KEYS.has(item.key)
    )
  }
  return ROSTER_PLAYER_SETUP_ITEMS.filter(
    (item) =>
      (item.key !== 'family' || showFamilySection) &&
      (isEdit ||
        !isFieldSectionKey(item.key) ||
        profileExtraSectionHasEditableFields(item.key))
  )
}
